<template>
  <div class="import_main" @click="isSpread = !isSpread">
    <span v-show="!isSpread" class="is_folded">导入/导出</span>
    <div v-show="isSpread" class="btn_list">
      <span class="btn_item padl_20" @click.stop="downTemplate(2)">连锁店模板</span>
      <span class="btn_item" @click.stop="downTemplate(1)">小区模板</span>
      <span class="btn_item">
        <el-upload ref="exportUpload" :headers="upHeaders" :show-file-list="false" :limit="1" accept=".xlsx" name="file"
          :action="upUrl(1)" :with-credentials="true" :before-upload="beforeUp" :on-progress="handleProgress"
          :on-success="handleSuccess" :on-error="handleError">
          <span>导入连锁店</span>
        </el-upload>
      </span>
      <span class="btn_item">
        <el-upload ref="exportUploadNbhd" :headers="upHeaders" :show-file-list="false" :limit="1" accept=".xlsx"
          name="file" :action="upUrl(2)" :with-credentials="true" :before-upload="beforeUp"
          :on-progress="handleProgress" :on-success="handleSuccessNbhd" :on-error="handleError">
          <span>导入小区</span>
        </el-upload>
      </span>
      <span class="btn_item export" @click.stop="onExport">导出结果</span>
      <span class="fold" @click.stop="isSpread = !isSpread">收起</span>
      <div v-if="isShowLoading" class="import_loading" @click.stop>
        <span>
          <i class="el-icon-document"></i>
          {{ uploadingFileName }}
        </span>
        <div class="imp_progress">
          <div class="percent_bar" :style="{ width: loadNum + '%' }"></div>
        </div>
      </div>
    </div>
    <!-- 错误提示对话框 -->
    <el-dialog :visible.sync="showErrorDialog" title="错误提示" width="600px" :close-on-click-modal="false">
      <div style="display:flex; align-items:flex-start;">
        <i class="el-icon-info" style="color:#2b90ff; font-size:32px; margin-right:12px;"></i>
        <div style="flex:1;">
          <div v-if="errorList && errorList.length" style="max-height:320px; overflow:auto; color:#666;">
            <ol style="padding-left:18px; margin:0 0 8px;">
              <li v-for="(it, idx) in errorList" :key="idx" style="margin-bottom:6px;white-space: normal;">{{ it }}</li>
            </ol>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="exportErrorReport">导出报错信息</el-button>
        <el-button type="primary" size="mini" @click="showErrorDialog = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { callAnimation, cancelAnimation } from '@/utils/functions'

export default {
  name: 'ExportFeatures',
  data() {
    return {
      isSpread: false,
      isShowLoading: false,
      upHeaders: {
        token: localStorage.getItem('user_ticket') || undefined
      },
      loadNum: 0,
      uploadingFileName: '',
      pointList: [],
      // 弹窗及错误数据
      showErrorDialog: false,
      errorList: [],
      errorMsg: '',
    }
  },
  computed: {
    zoomRegion() {
      return this.$store.state.bmap.mapZoomData
    },
    upUrl() {
      let addressCode = ''
      let seniorCityGuid = this.$store.state.bmap.mapSearchOptionsSenior.city
      if (!seniorCityGuid) {
        // addressCode = this.zoomRegion.city.districtCode
        addressCode = null
      } else {
        addressCode = this.$store.state.bmap.mapCityList.filter(el => el.guid == seniorCityGuid)[0].dicCode || ''
      }
      return type => {
        return type === 1 ?
          `/boss/deviceSlot/v2/importSearchPoint${addressCode ?'?addressCode=' + addressCode: ''}` :
          `/boss/deviceSlot/v2/importIntelligentNbhd${addressCode ?'?addressCode=' + addressCode: ''}`
      }
    }
  },
  methods: {
    async downTemplate(type) {
      await this.$exportGet('/boss/deviceSlot/v2/exportTemplate', { type })
    },
    beforeUp() {
      let round = this.$store.state.bmap.mapSearchOptionsSenior.areaValue
      if (!round || round == 0) {
        this.messageTip('请选择投放范围后导入连锁店')
        return false
      }
    },
    handleProgress(event, file) {
      this.uploadingFileName = file.name
      this.loadNum = event.percent
      if (!this.isShowLoading) this.isShowLoading = true
      // this.loadNum = 10
      // this.setProgress()
    },
    setProgress() {
      if (this.loadNum < 100) {
        this.loadNum += 5
        cancelAnimation(this.frameId)
        this.frameId = callAnimation(this.setProgress)
      } else {
        cancelAnimation(this.frameId)
      }
    },
    handleSuccess(res, _file, _fileList) {
      const t = setTimeout(() => {
        clearTimeout(t)
        this.isShowLoading = false
        if (res && res.code == 0 && res.data) {


          if (res.data.pointList && res.data.pointList.length > 0) {
            this.$store.commit('setImportNbhdList', [])
            this.$store.commit('setImportPointData', res.data)
            this.$store.commit('setImportPointList', res.data.pointList)
            this.$emit('upSus', { ...res.data, list: res.data.pointList }, 2)
          } else {
            this.messageTip('请填写正确的连锁店名称或地址')
          }
        } else {
          console.log(res)
          // 非 0 code，也可能包含详细错误信息
          // 若后端返回了错误地址列表，弹窗显示
          const errors = (res && (res.message || res.msg)).split('\n') || []
          if (errors && errors.length > 0) {
            this.errorList = errors
            this.showErrorDialog = true
            this.errorMsg = res.message
          } else {
            this.messageTip(res.msg || '上传失败，请稍后重试')
          }
        }
      }, 300)
      this.$refs.exportUpload.clearFiles()
    },
    handleSuccessNbhd(res) {
      const t = setTimeout(() => {
        clearTimeout(t)
        this.isShowLoading = false
        if (res && res.code == 0 && res.data) {
          if (res.data.nbhdSearchList && res.data.nbhdSearchList.length > 0) {
            this.$store.commit('setImportNbhdList', res.data.nbhdSearchList)
            this.$store.commit('setImportPointList', [])
            this.$store.commit('setImportPointData', {})
            this.$emit('upSus', { ...res.data, list: res.data.nbhdSearchList }, 1)
          } else {
            this.messageTip('文件中暂无小区点位')
          }
        } else {
          this.messageTip(res ? (res.msg || '上传失败，请稍后重试') : '上传失败，请稍后重试')
        }
      }, 300)
      this.$refs.exportUploadNbhd.clearFiles()
    },
    // 导出错误信息为文本文件
    async exportErrorReport() {
      // if (!this.errorList || this.errorList.length === 0) return
      // const content = this.errorList.map((it, idx) => `${idx + 1}. ${it}`).join('\r\n')
      // const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
      // const url = window.URL.createObjectURL(blob)
      // const a = document.createElement('a')
      // a.href = url
      // a.download = 'upload_error_report.txt'
      // document.body.appendChild(a)
      // a.click()
      // document.body.removeChild(a)
      // window.URL.revokeObjectURL(url)
      await this.$export('/boss/deviceSlot/v2/addresses/export',{message:this.errorMsg})
      // this.showErrorDialog = false
    },
    handleError(error, data) {
      this.isShowLoading = false
      this.messageTip('上传失败，请稍后重试')
      if (this.$refs.exportUpload) this.$refs.exportUpload.clearFiles()
      if (this.$refs.exportUploadNbhd) this.$refs.exportUploadNbhd.clearFiles()
      // if (data.size > 2 * 1024 * 1024) return this.messageTip('文件不能大于2M')
    },
    onExport() {
      this.$emit('exportResult')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body{
  padding: 15px 20px;
}
.import_main {
  cursor: pointer;
  display: inline-block;
  border: 1px solid #D4D4D4;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  margin-right: 10px;
  font-size: 14px;
  .is_folded {
    padding: 0 20px;
  }
  .btn_list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .btn_item {
      display: inline-block;
      padding: 0 16px;
      height: 20px;
      line-height: 20px;
      border-right: 1px solid #D4D4D4;
      &.padl_20 {
        padding-left: 20px;
      }
      &.export {
        border-right: none;
      }
    }
    .fold {
      height: 28px;
      line-height: 28px;
      background: #E4E4E4;
      border-radius: 0 4px 4px 0;
      color: #999;
      padding: 0 20px;
    }
  }
  .import_loading {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 64px;
    padding: 12px 20px 18px;
    border-radius: 4px;
    z-index: 10;
    background: #fff;
    .el-icon-document {
      margin-right: 5px;
    }
    .imp_progress {
      width: 100%;
      height: 2px;
      background: #E9E9E9;
      .percent_bar {
        background: #FF3973;
        height: 2px;
      }
    }
  }
}
</style>
